// extracted by mini-css-extract-plugin
export default {"searchList":"SuggestionsList_searchList__ROw+k","subtitle":"SuggestionsList_subtitle__qVQOd"};